import React from 'react'
import { ReplyOption, ThreadConversationData } from './conversation'
import { Attachment } from '../../../components/media/attachment'
import { AudioButton } from '../../../components/media/audioButton'
import { Avatar } from '../../../components/avatar'
import { ButtonStyle, ButtonShape, Button } from '../../../components/simple/button'
import { DateWrapper } from '../../../components/simple/date'
import {
  IconTeacherOnly,
  IconAnnouncement,
  IconWarningCircle,
  IconEmail,
  IconWhatsapp,
  IconReply,
} from '../../../icons/library'
import { HoverPopover } from '../../../layouts/components/popover'
import { MessageTags } from '../messageTags'
import { TruncatedText } from '../../../components/simple/truncatedText'
import { MessageInfoLauncher } from '../../modals/messageinfo/messageInfo'
import { ConfirmReceiptPie } from '../message'

export const TextConversation: React.FC<{
  data: ThreadConversationData
  showArchived: boolean
  setReplyOption: (replyOption: ReplyOption) => void
}> = ({ data, showArchived, setReplyOption }) => {
  return (
    <div className="m-2 flex flex-col gap-1">
      {data.thread.map((m) => (
        <div key={m.id} className={`flex items-center gap-2 ${m.sendersPerspective ? 'flex-row-reverse' : 'flex-row'}`}>
          {m.avatar ? (
            <Avatar className="self-start" src={m.avatar} size="sm" />
          ) : (
            <div className="w-[25px] flex-shrink-0"></div>
          )}

          <MessageInfoLauncher
            messageID={m.id}
            canLaunch={m.canViewMessageInfo}
            className={`rounded-lg ${m.sendersPerspective ? 'bg-logo text-white [&_a]:!text-white' : 'bg-gray-50'} max-w-[60%] p-2`}
            cursor={`cursor-pointer ${m.sendersPerspective ? 'hover:bg-logo-600' : 'hover:bg-gray-100'} transition-colors duration-75`}
          >
            {m.archived && !showArchived ? (
              <div>Archived Message</div>
            ) : (
              <>
                <TruncatedText lines={13} className="leading-5">
                  <div style={{ wordWrap: 'break-word' }} dangerouslySetInnerHTML={{ __html: m.content }} />
                </TruncatedText>
                {m.attachments && m.attachments.length > 0 && (
                  <div className="mt-2 flex gap-2">
                    {m.attachments.map((a, i) => (
                      <Attachment key={i} attachment={a} />
                    ))}
                  </div>
                )}
              </>
            )}
          </MessageInfoLauncher>
          <div className={`flex items-center gap-1 text-nowrap text-[10px] text-stone-500`}>
            {m.teacherOnly && <IconTeacherOnly tooltip="Only to teachers" />}
            {m.tags && (
              <HoverPopover trigger={<IconAnnouncement />}>
                <div className="p-2">
                  <MessageTags tags={m.tags} />
                </div>
              </HoverPopover>
            )}
            {m.undeliveredInfo && (
              <IconWarningCircle
                opacity={50}
                tooltip={<div dangerouslySetInnerHTML={{ __html: m.undeliveredInfo }} />}
              />
            )}
            {m.sentAsEmail && <IconEmail opacity={30} tooltip="Sent as email" />}
            {m.sentAsWhatsApp && <IconWhatsapp opacity={30} tooltip="Sent through WhatsApp" />}
            {m.extraLabelForText || ''}
            <DateWrapper date={m.date} />
            {m.confirmReceiptPie && (
              <ConfirmReceiptPie pie={m.confirmReceiptPie} messageID={m.id} canViewMessageInfo={m.canViewMessageInfo} />
            )}
            {m.audioUrl && <AudioButton url={m.audioUrl} />}
            {m.directReply && (
              <Button
                buttonStyle={ButtonStyle.light}
                shape={ButtonShape.iconCircleSmall}
                onClick={() => setReplyOption(m.directReply!)}
              >
                <IconReply />
              </Button>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
